
// this file is automatically generated by version.ts script
export const versions = {
  revision: '2934f7eb01afda30721712e4a77f60d9928cca7a',
  version: '1.120.0',
};
